export const FETCH_CORRESPONDENT_LIST = 'src/Admin/Correspondent-Onboarding/List/action/Fetch_Correspondent_List';
export const FETCH_CORRESPONDENT_LIST_SUCCESS = 'src/Admin/Correspondent-Onboarding/List/action/Fetch_Correspondent_List_Success';
export const FETCH_CORRESPONDENT_LIST_FAILURE = 'src/Admin/Correspondent-Onboarding/List/action/Fetch_Correspondent_List_Failure';

export const fetchCorrespondentList = () => {
    return {
        type: FETCH_CORRESPONDENT_LIST,
    }
}
export const fetchCorrespondentListSuccess = (data) => {
    return {
        type: FETCH_CORRESPONDENT_LIST_SUCCESS,
        data
    }
}
export const fetchCorrespondentListFailure = (data) => {
    return {
        type: FETCH_CORRESPONDENT_LIST_FAILURE,
        data
    }
}

export const ENABLE_CORRESPONDENT = 'src/Admin/Correspondent-Onboarding/List/action/Enable_Correspondent';
export const ENABLE_CORRESPONDENT_SUCCESS = 'src/Admin/Correspondent-Onboarding/List/action/Enable_Correspondent_Success';
export const ENABLE_CORRESPONDENT_FAILURE = 'src/Admin/Correspondent-Onboarding/List/action/Enable_Correspondent_Failure';

export const enableCorrespondent = (data) => {
    return {
        type: ENABLE_CORRESPONDENT,
        data
    }
}
export const enableCorrespondentSuccess = (data) => {
    return {
        type: ENABLE_CORRESPONDENT_SUCCESS,
        data
    }
}
export const enableCorrespondentFailure = (data) => {
    return {
        type: ENABLE_CORRESPONDENT_FAILURE,
        data
    }
}

export const DELETE_CORRESPONDENT_ENTITY = 'src/Admin/Correspondent-Onboarding/List/action/Delete_Correspondent_Entity';
export const DELETE_CORRESPONDENT_ENTITY_SUCCESS = 'src/Admin/Correspondent-Onboarding/List/action/Delete_Correspondent_Entity_Success';
export const DELETE_CORRESPONDENT_ENTITY_FAILURE = 'src/Admin/Correspondent-Onboarding/List/action/Delete_Correspondent_Entity_Failure';

export const deleteCorrespondentEntity = (data) => {
    return {
        type: DELETE_CORRESPONDENT_ENTITY,
        data
    }
}
export const deleteCorrespondentEntitySuccess = (data) => {
    return {
        type: DELETE_CORRESPONDENT_ENTITY_SUCCESS,
        data
    }
}
export const deleteCorrespondentEntityFailure = (data) => {
    return {
        type: DELETE_CORRESPONDENT_ENTITY_FAILURE,
        data
    }
}

